module.exports = __webpack_public_path__ + "static/awards-icon-2-e4972f9c54ad45f972535667382c91b4.png";